var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBounceLoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFEA25",
    stroke: "#FFEA25",
    strokeWidth: 15,
    width: 30,
    height: 30,
    x: 25,
    y: 50
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    calcMode: "spline",
    dur: 2,
    values: "50;120;50;",
    keySplines: ".5 0 .5 1;.5 0 .5 1",
    repeatCount: "indefinite",
    begin: -0.4
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFEA25",
    stroke: "#FFEA25",
    strokeWidth: 15,
    width: 30,
    height: 30,
    x: 85,
    y: 50
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    calcMode: "spline",
    dur: 2,
    values: "50;120;50;",
    keySplines: ".5 0 .5 1;.5 0 .5 1",
    repeatCount: "indefinite",
    begin: -0.2
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFEA25",
    stroke: "#FFEA25",
    strokeWidth: 15,
    width: 30,
    height: 30,
    x: 145,
    y: 50
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    calcMode: "spline",
    dur: 2,
    values: "50;120;50;",
    keySplines: ".5 0 .5 1;.5 0 .5 1",
    repeatCount: "indefinite",
    begin: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBounceLoad);
export default __webpack_public_path__ + "static/media/bounceLoad.7200816e32d63d5abb04344879c57ad8.svg";
export { ForwardRef as ReactComponent };